import { useEffect, useState } from "react";

const DEFAULT_POLL_MS = 500;

export function usePendingRequests(pollMs: number = DEFAULT_POLL_MS): number {
  const [pendingRequests, setPendingRequests] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      const fetchQueue = (window as any).fetchQueue;
      if (!fetchQueue) return;

      setPendingRequests(fetchQueue.getQueueLength() + fetchQueue.getActiveRequests());
    }, pollMs);

    return () => clearInterval(interval);
  }, [pollMs]);

  return pendingRequests;
}
